import React from 'react';
import { Box, Typography, Button, Stack, Pagination, PaginationItem } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';
import PayoutInvoiceFilters from './PayoutInvoiceFilters';
import PayoutInvoicesTable from './PayoutInvoicesTable';
import { usePayoutInvoices } from '../hooks/usePayoutInvoices';

/** Вкладка «Счета»: заявки payout_invoices с фильтром по статусам и пагинацией. */
const PayoutsOutLimits: React.FC = () => {
  const {
    invoices,
    traders,
    error,
    loading,
    totalPages,
    filters,
    handleFilterChange,
    handleSearch,
    handleReset,
    handlePageChange,
    handleRefresh,
  } = usePayoutInvoices();

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5" sx={{ fontWeight: 600 }}>
          Счета
        </Typography>
        <Button variant="contained" onClick={handleRefresh} disabled={loading} startIcon={<RefreshIcon />}>
          Обновить
        </Button>
      </Box>

      <Box sx={{ mb: 3 }}>
        <PayoutInvoiceFilters
          filters={filters}
          traders={traders}
          onFilterChange={handleFilterChange}
          onSearch={handleSearch}
          onReset={handleReset}
        />
      </Box>

      <PayoutInvoicesTable
        invoices={invoices}
        loading={loading}
        error={error}
        onClaimChanged={handleRefresh}
      />

      {totalPages > 1 && (
        <Stack spacing={2} alignItems="center" sx={{ mt: 3 }}>
          <Pagination
            count={totalPages}
            page={filters.page}
            onChange={handlePageChange}
            color="primary"
            showFirstButton
            showLastButton
            renderItem={(item) => <PaginationItem {...item} disabled={item.page === filters.page} />}
          />
        </Stack>
      )}
    </Box>
  );
};

export default PayoutsOutLimits;
